import { z } from "zod/v4";

/** Past this from its start, a screenshot still pending will not arrive: the page-shot route's 30 s, plus a margin. */
export const SCREENSHOT_DEADLINE_MS = 35_000;

/** Where a card's screenshot is kept in the public static bucket, known from the pick on. */
export const auditScreenshotPath = (orgId: string, recommendationId: string) =>
  `opportunity-audit/screenshot/${orgId}/${recommendationId}.jpg`;

// Shown and missing are read only, for cards stored while a card held its
// shot's result. No card is written with them now.
const ShownSchema = z.object({
  type: z.literal("shown"),
  url: z.string(),
  view: z.enum(["desktop", "phone"]),
  /** Why the image carries no mark, when it carries none. */
  unmarked: z.enum(["notVisible", "covered", "noPlace"]).optional(),
});

const MissingSchema = z.object({
  type: z.literal("missing"),
  reason: z.enum(["notFound", "failed"]),
});

/**
 * A content card's screenshot of its page, with the place the test changes
 * marked. The card says at the pick whether one is coming: `pending`, with
 * where the image will be and when its shot started, or `none`.
 */
export const AuditScreenshotSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("pending"),
    startedAt: z.string(),
    /** Absent on a card from before the URL was set at the pick. */
    url: z.string().optional(),
  }),
  z.object({ type: z.literal("none") }),
  ShownSchema,
  MissingSchema,
]);

export type AuditScreenshot = z.infer<typeof AuditScreenshotSchema>;
